import React from "react";
import { connect } from "react-redux";
import { getNumeroPatronal, eliminarNumeroPatronal } from "../numeroPatronal/NumeroPatronalService";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";

import NavbarConfiguraciones from "../componentes/NavbarConfiguraciones.js";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion.js";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";

class NumerosPatronales extends React.Component {

  constructor(props) {
    super(props);
    const { location } = this.props;
    const estado = location && location.state ? location.state : {};

    this.state = {
      elementoSeleccionado: null,
      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
      ventanaEliminar: false,
      openPantallaCarga: false,

    }
    this.tablaRef = React.createRef();
    this.modalEliminarRef = React.createRef();
  }

  handleEditarDatos = (dato) => {
    this.props.history.push({
      pathname: '/configuracion/numero-patronal/edit',
      state: { numeroPatronal: dato }
    })
  }

  handleDialogEliminarDatos = (estado, id = null) => {
    this.setState({ ventanaEliminar: estado, elementoSeleccionado: id }, () => {
      if (estado && id && this.modalRef) {
        this.modalRef.cargarDetalles(id);
      }
    });
  };

  abrirModalEliminar = (estado, documento = null) => {
    this.setState({
      ventanaEliminar: estado,
      elementoSeleccionado: documento,
    });
  }

  cerrarModalEliminar = () => {
    this.setState({ ventanaEliminar: false });
  }


  eliminar = () => {
    this.modalEliminarRef.cerrarModalConAnimacion()
    this.setState({ openPantallaCarga: true });
    let numeroPatronal = this.state.elementoSeleccionado;

    this.props.eliminarNumeroPatronal(numeroPatronal.id).then((response) => {
      this.setState({
        openPantallaCarga: false,
        mostrarMensajeFlash: true,
        mensajeFlash: response.mensaje,
        mensajeFlashSeverity: response.error ? 'error' : 'exito'
      });
      this.actualizarDatosTabla()
    })
  }

  fetchNroPatronal = (page, pageSize, search) => {
    return this.props.getNumeroPatronal(page, pageSize, search).then(() => {
      const { numeroPatronalData } = this.props;
      return {
        items: numeroPatronalData.numeroPatronal,
        totalCount: numeroPatronalData.totalCount,
      };
    });
  };

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.id}>
        <td>{f.descripcion}</td>
        <td>{f.numero}</td>
        <td>
          <div className="table-actions">
            <button className="table-icon open-dialog" onClick={() => this.handleEditarDatos(f)}>
              <span className="material-symbols-outlined"> edit </span>
            </button>
            <button className="table-icon open-dialog" data-dialog="modal-delete-details" onClick={() => this.abrirModalEliminar(true,f)}>
              <span className="material-symbols-outlined"> delete </span>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  }

  render() {
    return (
      <div>
        <div className="template-base">
          <PantallaCarga open={this.state.openPantallaCarga} />

          <NavbarConfiguraciones
            titulo={"Números del MTESS Patronal"}
            descripcion={""}
            textoBoton={"Agregar nuevo número patronal"}
            direccionBoton={"/configuracion/numero-patronal/nuevo"}
          />
          <div className="wrapperContent">
            <div className="page-container">
              <TablaItemsConfiguracion
                ref={(ref) => (this.tablaRef = ref)}
                titulo="Números patronales disponibles"
                headers={["Descripcion", "Número de patronal", "Acciones"]}
                fetchDatos={this.fetchNroPatronal}
                renderFilas={this.renderFilas}

              />
            </div>
            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>
          <ModalEliminarConDetalles
            ref={(ref) => (this.modalEliminarRef = ref)}
            isOpen={this.state.ventanaEliminar}
            cerrarModal={this.cerrarModalEliminar}
            onConfirmar={this.eliminar}
            elemento={this.state.elementoSeleccionado}
            titulo="número de patronal"
            detallesAMostrar={[
              { clave: 'descripcion', etiqueta: 'Descripcion' },
            ]}
            mensaje="Esta acción eliminará permanentemente el elemento"
            textoBotonAccion="CONFIRMAR ELIMINACIÓN"
          />
        </div>

      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getNumeroPatronal: (page, size, search) => dispatch(getNumeroPatronal(page, size, search)),
  eliminarNumeroPatronal: (id) => dispatch(eliminarNumeroPatronal(id))
});

const mapStateToProps = (state) => ({
  numeroPatronalData: state.numeroPatronalData,
});

export default connect(mapStateToProps, mapDispatchToProps)(NumerosPatronales);
